import { createContext, useContext, useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase/firebaseConfig";

const SiteSettingsContext = createContext({
  hostEnabled: false,
  loading: true,
  error: null,
  forcedHost: false,
});

const FORCE_HOST = process.env.REACT_APP_FORCE_HOST === "true";

/**
 * Reads bitly/siteSettings.Host from Firestore in real time.
 * Host === true  → show host app (Inkwell blog)
 * Host === false → show bit app
 * REACT_APP_FORCE_HOST=true in .env locks blog mode and ignores admin toggle
 */
export const SiteSettingsProvider = ({ children }) => {
  const [hostEnabled, setHostEnabled] = useState(FORCE_HOST ? true : null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (FORCE_HOST) {
      setHostEnabled(true);
      console.warn(
        "[SiteSettings] REACT_APP_FORCE_HOST=true — admin Bit/Host toggle is ignored. Set false in host/.env to follow Firestore."
      );
      return undefined;
    }

    const ref = doc(db, "bitly", "siteSettings");

    const unsub = onSnapshot(
      ref,
      (snap) => {
        const data = snap.data();
        setHostEnabled(Boolean(data?.Host));
        setError(null);
      },
      (err) => {
        console.error("SiteSettings listener error:", err);
        setHostEnabled(false);
        setError(err.message);
      }
    );

    return unsub;
  }, []);

  return (
    <SiteSettingsContext.Provider
      value={{
        hostEnabled: hostEnabled ?? false,
        loading: hostEnabled === null,
        error,
        forcedHost: FORCE_HOST,
      }}
    >
      {children}
    </SiteSettingsContext.Provider>
  );
};

export const useSiteSettings = () => useContext(SiteSettingsContext);
